<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="breadcrumb" (goTo)="breadcrumbGoTo($event)"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="location-edit-name">Name</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="locationData.name"
                  name="name"
                  #name="ngModel"
                  class="form-control"
                  id="location-edit-name"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(name.touched || name.dirty) && !name.valid"> Name is invalid. </small>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    id="is-city-checkbox"
                    (change)="markAsCity(cityCh.checked)"
                    #cityCh
                    type="checkbox"
                    name="isCity"
                    [(ngModel)]="locationData.isCity"
                    #isCity="ngModel"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="is-city-checkbox">Is City?</label>
                </div>
              </div>
              <div class="form-group">
                <label for="location-edit-city-name">City Name In EN</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="locationData.cityName"
                  name="cityName"
                  #cityName="ngModel"
                  class="form-control"
                  id="location-edit-city-name"
                  [readonly]="loading || !locationData.isCity"
                  [required]="locationData.isCity"
                />
                <small class="text-danger" *ngIf="(cityName.touched || cityName.dirty) && !cityName.valid"> City Name is invalid. </small>
              </div>
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    id="is-country-checkbox"
                    (change)="markAsCountry(countryCh.checked)"
                    #countryCh
                    type="checkbox"
                    name="isCountry"
                    [(ngModel)]="locationData.isCountry"
                    #isCountry="ngModel"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="is-country-checkbox">Is Country?</label>
                </div>
              </div>
              <div class="form-group">
                <label for="location-edit-country-name">Country Name In EN</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="locationData.countryName"
                  name="countryName"
                  #countryName="ngModel"
                  class="form-control"
                  id="location-edit-country-name"
                  [readonly]="loading || !locationData.isCountry"
                  [required]="locationData.isCountry"
                />
                <small class="text-danger" *ngIf="(countryName.touched || countryName.dirty) && !countryName.valid">
                  Country Name is invalid.
                </small>
              </div>
              <div class="form-group">
                <label for="location-edit-country-name">Country Name (Umbraco)</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="locationData.nameUmbraco"
                  name="nameUmbraco"
                  #nameUmbraco="ngModel"
                  class="form-control"
                  id="location-edit-country-name"
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(nameUmbraco.touched || nameUmbraco.dirty) && !nameUmbraco.valid">
                  Country Name (Umbraco) is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="location-edit-sku">Latitude</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="locationData.latitude"
                  name="latitude"
                  #latitude="ngModel"
                  class="form-control"
                  id="location-edit-sku"
                  [required]="locationData.isCity"
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(latitude.touched || latitude.dirty) && !latitude.valid"> Latitude is invalid. </small>
              </div>
              <div class="form-group">
                <label for="location-edit-sku">Longitude</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="locationData.longitude"
                  name="longitude"
                  #longitude="ngModel"
                  class="form-control"
                  id="location-edit-sku"
                  [required]="locationData.isCity"
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(longitude.touched || longitude.dirty) && !longitude.valid">
                  Longitude is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="location-edit-currency-sign">Currency Sign</label>
                <input
                  type="text"
                  id="location-edit-currency-sign"
                  class="form-control"
                  [(ngModel)]="locationData.currencySign"
                  name="currencySign"
                  #currencySign="ngModel"
                  [readonly]="loading"
                  required
                />
                <small
                  class="text-danger"
                  *ngIf="errors.currencySign || ((currencySign.touched || currencySign.dirty) && !currencySign.valid)"
                >
                  The Currency Sign {{ errors.currencySign || 'is invalid' }}.
                </small>
              </div>

              <div class="form-group">
                <label for="currency-format-dropdown">Currency Format</label>
                <select
                  id="currency-format-dropdown"
                  [(ngModel)]="locationData.signAtTheBack"
                  name="signAtTheBack"
                  class="form-control"
                  #signAtTheBack="ngModel"
                  required
                >
                  <option value="true">
                    <span>1{{ locationData.currencySign || 'currency' }}</span></option
                  >
                  <option value="false"
                    ><span>{{ locationData.currencySign || 'currency' }} 1 </span></option
                  >
                </select>
                <small
                  class="text-danger"
                  *ngIf="errors.signAtTheBack || ((signAtTheBack.touched || signAtTheBack.dirty) && !signAtTheBack.valid)"
                >
                  Currency Format is required.
                </small>
              </div>

              <div *ngIf="loaded">
                <agm-map [latitude]="initialLat" [longitude]="initialLng" (mapClick)="onLocationChange($event)">
                  <agm-marker *ngIf="chosenLocation" [latitude]="locationData.latitude" [longitude]="locationData.longitude"></agm-marker>
                </agm-map>
              </div>

              <div style="margin-top: 40px;">
                <button id='locationEditDelete' type="button" class="btn btn-danger" (click)="delete()" [disabled]="loading">Delete</button>
                <span class="btn-right">
                  <button id='locationEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='locationEditSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/locations/location-edit/location-edit.component.html